<template>
	<div class="content">
		<div class="content__row">
			<div class="content__column content__column--wide">
				<h1 class="content__title">Productos</h1>
			</div>
		</div>
		<div class="content__row">
			<product-list :filters="filters"></product-list>
			<product-view :product="product" v-if="productAction === 'view' && product"></product-view>
			<product-edit @new="newProduct" :product="product" v-if="productAction === 'edit'" :key="key"></product-edit>
			<div class="content__column content__column--small">
				<h1 class="content__title">Opciones</h1>
				<div class="information">
					<h2 class="content__subtitle">Navegación</h2>
					<router-link class="btn btn__action btn--small" :to="{ name: 'brandView' }">Diseñadores</router-link>
					<router-link class="btn btn__action btn--small" :to="{ name: 'attributesView' }">Atributos de producto</router-link>
					<router-link class="btn btn__action btn--small" :to="{ name: 'productCategoryView' }">Categorías</router-link>
					<h2 class="content__subtitle">Filtro</h2>
					<div class="form__container">
						<label for="search" class="form__label">búsqueda Libre</label>
						<input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters" />
					</div>
					<div class="form__container">
						<label class="form__label form__label--required" for="status_id">Filtrar por estatus</label>
						<div class="form__select-container">
							<select name="status_id" id="status_id" class="form__select" v-model="status_id" @change="setFilters">
								<option hidden :value="null">Selecciona un estatus</option>
								<option v-for="(status, index) in product_status" :key="index" :value="status.id" v-text="status.name"></option>
							</select>
						</div>
					</div>
					<div class="form__container">
						<label class="form__label form__label--required" for="categoryId">Filtrar por Categoría</label>
						<div class="form__select-container">
							<select name="categoryId" id="categoryId" class="form__select" v-model="categoryId" @change="setFilters">
								<option :value="null">Todas las categorías</option>
								<option v-for="(category, index) in categories" :key="index" :value="category.id" v-text="category.title_es"></option>
							</select>
						</div>
					</div>
					<div class="form__container">
						<label class="form__label form__label--required" for="designerId">Filtrar por diseñador</label>
						<div class="form__select-container">
							<select name="designerId" id="designerId" class="form__select" v-model="designerId" @change="setFilters">
								<option :value="null">Todos los diseñadores</option>
								<option v-for="(designer, index) in designers" :key="index" :value="designer.id" v-text="designer.name"></option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
		<button @click.prevent="newProduct" class="btn btn__add">Agregar</button>
	</div>
</template>

<script>
	import httpService from '@/core/api/request'
	import productList from './list'
	import productView from './view'
	import productEdit from './edit'
	import Mixins from './mixins'
	import { product_status } from './mocks'
	export default {
		mixins: [httpService, Mixins],
		components: {
			productList,
			productView,
			productEdit
		},
		data: function() {
			return {
				product_status: product_status,
				key: 0,
				search: null,
				designerId: null,
				status_id: null,
				product: null,
				filters: undefined,
				productAction: null,
				products: null,
				categoryId: null
			}
		},
		created: function() {
			this.getDesigners()
			this.getCategories()
		},
		mounted: function() {
			this.$on('view', id => {
				this.getProduct(id, 'view')
			})
			this.$on('edit', id => {
				this.getProduct(id, 'edit')
			})
		},
		methods: {
			setFilters: function() {
				let filter = ''
				if (this.search && this.search.length > 1) {
					filter = filter + '&search=' + this.search
				}
				if (this.status_id) {
					filter = filter + '&status_id=eq:' + this.status_id
				}
				if (this.designerId) {
					filter = filter + '&designer_id=eq:' + this.designerId
				}
				if (this.categoryId) {
					filter = filter + '&category_id=eq:' + this.categoryId
				}
				filter = filter.replace(/(^&+|&+$)/, '')
				if (filter.length > 0) {
					this.filters = filter
				} else {
					this.filters = undefined
				}
			},
			getProduct: function(id, action) {
				this.productAction = null
				let httpRequest = {
					params: '',
					module: 'products'
				}
				this.getById(id, httpRequest).then(product => {
					this.product = product.data
					this.productAction = action
				})
			},
			newProduct: function() {
				this.product = undefined
				this.key = ++this.key
				this.productAction = 'edit'
			}
		}
	}
</script>

<style lang="sass">
	@import "../../assets/sass/components/_home"
	@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/products/products.vue